import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { PROTECTED_ROUTES } from "../routes";
import NavBar from "components/NavBar";
import ScrollToTop from "components/ScrollToTop";
import { Box, useBreakpointValue } from "@chakra-ui/react";
import SideBar from "components/SideBar";
import { useState } from "react";

const Authenticated = () => {
  const routes = useRoutes(PROTECTED_ROUTES);
  return routes;
};

const AppWrapper = () => {
  const smVariant = { navigation: "drawer", navigationButton: true };
  const mdVariant = { navigation: "sidebar", navigationButton: false };
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const variants = useBreakpointValue({ base: smVariant, md: mdVariant });

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <Router>
      <ScrollToTop />
      <NavBar />

      <Box
        display={{
          base: "block",
          sm: "block",
          md: "block",
          lg: "grid",
          xl: "grid",
          "2xl": "grid",
        }}
        gridTemplateColumns="200px auto"
      >
        <Box
          display={{
            base: "none",
            md: "none",
            lg: "grid",
            xl: "grid",
            "2xl": "grid",
          }}
        >
          <SideBar variant={variants?.navigation} isOpen={isSidebarOpen} onClose={toggleSidebar} />
        </Box>

        <Authenticated />
      </Box>
    </Router>
  );
};
export default AppWrapper;
